import { adminHttp } from './adminHttp'

/** 구독 관리 */
export const adminSubscriptionApi = {
  dashboard: () =>
    adminHttp.get(
      '/admin/subscription/dashboard',
      b => b.data,
      '구독 현황 조회 실패'
    ),

  resetUsage: () =>
    adminHttp.post(
      '/admin/subscription/reset-usage',
      {},
      b => b.data ?? b,
      '사용량 초기화 실패'
    ),
}

export default adminSubscriptionApi
